<template>
  <path
    d="M19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM13 17.0002C12.45 17.0002 12 16.5502 12 16.0002V9.00018H11C10.45 9.00018 10 8.55018 10 8.00018C10 7.45018 10.45 7.00018 11 7.00018H13C13.55 7.00018 14 7.45018 14 8.00018V16.0002C14 16.5502 13.55 17.0002 13 17.0002Z"
  />
</template>
